import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { GiBrain } from 'react-icons/gi';
import { usePasswordAccess } from '../hooks/usePasswordAccess';
import * as FiIcons from 'react-icons/fi';

const { FiLogOut } = FiIcons;

function SharedHeader() {
  const { revokeAccess } = usePasswordAccess();

  const handleLogout = () => {
    if (window.confirm('Sei sicuro di voler uscire? Dovrai reinserire la password per accedere nuovamente.')) {
      revokeAccess();
      window.location.reload();
    }
  };

  return (
    <header className="text-center mb-12 flex items-center justify-center flex-col">
      {/* Logout button */}
      <div className="w-full flex justify-end mb-6">
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 bg-white rounded-2xl shadow-lg p-4 border border-gray-100 text-gray-600 hover:text-red-600 hover:bg-red-50 transition-all duration-200"
          title="Esci dall'app"
        >
          <SafeIcon icon={FiLogOut} className="text-lg" />
          <span className="font-medium">Esci</span>
        </button>
      </div>

      {/* Main Header */}
      <div className="flex items-center mb-6">
        <div className="bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 p-3 rounded-2xl mr-4 shadow-lg">
          <SafeIcon icon={GiBrain} className="text-white text-5xl" />
        </div>
        <h1 className="text-5xl font-black bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 bg-clip-text text-transparent">
          Mindset Supremo
        </h1>
      </div>
      
      <p className="text-xl text-gray-700 font-medium max-w-2xl">
        Coltiva la tua mentalità e raggiungi i tuoi obiettivi con stile
      </p>

      {/* Database Status */}
      <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-2xl max-w-2xl">
        <p className="text-green-700 text-sm text-center">
          🟢 Connesso a Supabase - I tuoi dati sono sincronizzati su tutti i dispositivi!
        </p>
      </div>

      {/* Shared access notice */}
      <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-xl max-w-2xl">
        <p className="text-blue-700 text-xs text-center">
          🔒 Accesso condiviso - Tutti i dispositivi con la password vedranno gli stessi dati
        </p>
      </div>
    </header>
  );
}

export default SharedHeader;